<template>
  <div>
    <div class="footer">
      <div class="footer-play">
          <p @click="eject=true">{{copyright.tl}}</p>
          <p>
              京ICP备0523886号&nbsp;&nbsp;<img src="../../../static/indexImg/ba.png" width="18" height="18" style="display: inline-block;">
                 京公网安备11010502034595号&nbsp;&nbsp;Copyright © 2019 本田技研工業（中国）投資有限公司
          </p>
      </div>
    </div>
    <div class="baseTextBox">
      <base-text-popup v-show="eject" :copyright = "copyright" @close="()=>eject = false"></base-text-popup>
    </div>
  </div>
</template>

<script>
  import BaseTextPopup from "../../pages/baseTextPopup/baseTextPopup";

  export default {
    name: "baseText",
    components: {BaseTextPopup},
    data(){
      return{
        eject: false,
        copyright:{},
      }
    },
    async mounted () {
      const json = await this.RequestUtil.request("/copyright");
      if(json) {
        if (json.statusCode == this.Constants.statusCode.ok) {
          this.copyright = json.datas.copyright;
        }
      }
    }
  }
</script>

<style scoped>
  .footer{
    width: 100%;
    height: 30px;
    margin-top: 20px;
  }
  .footer-play{
    width: 800px;
    height: 30px;
    margin: 0 auto;
  }
  .footer-play p{
    text-align: center;
    line-height: 30px;
    color: #626262;
    cursor: pointer;
  }
  .baseTextBox{
    position: absolute;
    z-index: 1100;
  }
</style>



// WEBPACK FOOTER //
// src/common/components/baseText.vue